<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474">
    <v-img height="250" :src="image03"></v-img>

    <v-card-title
      >Sobre o
      <span style="font-family: 'Fontdiner Swanky', serif;"
        >VIOLENT NOISE</span
      ></v-card-title
    >

    <v-card-text>
      <!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

      <div class="my-4 subtitle-1 black--text">
        + • <span style="font-family: 'Fontdiner Swanky', serif;">VIOLENT NOISE</span>, Projeto, Descrição
      </div>
-->

      <div>
        O
        <span style="font-family: 'Fontdiner Swanky', serif;"
          >VIOLENT NOISE</span
        >
        é um espaço destinado aos apreciadores do Rock, Hardcore, Metal e todas as suas subdivisões e vertentes.
      </div>
      <div>
      Trata-se de um ambiente virtual para conhecer, compartilhar e discutir o cenário Underground tanto musical como cultural.
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title>Visite nossas redes sociais</v-card-title>

      <v-card-text>
        <v-btn v-for="(item, index) in socials" :key="index" class="mx-4 grey lighten-2" icon @click="goLink(item.link)">
          <v-icon size="24px">{{ item.ico }}</v-icon>
        </v-btn>
      </v-card-text>
    <!--
    <v-card-actions>
      <v-btn color="deep-purple accent-4" text @click="reserve">
        Envie um email
      </v-btn>
    </v-card-actions>
-->
  </v-card>
</template>

<script>
const image3 = require("@/assets/images/content/guitar.jpg");

export default {
  data: () => ({
    image03: image3,
    loading: false,
    selection: 0,
    socials: [
      { 
        ico: 'mdi-facebook',
        link: 'https://www.facebook.com/violentnoiseblog/'
      },
      /*
      { 
        ico: 'mdi-twitter',
        link: ''
      },
      */
      { 
        ico: 'mdi-blogger',
        link: 'https://blog.violentnoise.com.br'
      },
      /*
      { 
        ico: 'mdi-linkedin',
        link: ''
      },
      */
      { 
        ico: 'mdi-instagram',
        link: 'https://www.instagram.com/violentnoiseblog'
      },
      { 
        ico: 'mdi-spotify',
        link: 'https://open.spotify.com/user/tco44mhstu8c0emses2spng10?si=z2YwNEM0QxaHaItu64Xa7A'
      },
    ],
  }),
  methods: {
    goLink: function (newLink) {
      window.open(newLink, "_blank");
    }
  }
};
</script>

<style></style>
